<template>
  <div>
    <div v-if="teacherList.length > 0" class="teacher-list">
      <TutorListHeader class="mb-4 lg:mb-6" />
      <TeacherListItems
        v-for="(teacher) in teacherList"
        :key="teacher.id"
        :teacher="teacher"
        @reviewClicked="reviewClicked"
        @bookingClicked="bookingClicked"
      />
      <div ref="showMoreBtn">
        <BaseButton
          v-if="showMoreStatus && isMounted"
          class="w-[176px] lg:w-[248px] mt-8 mx-auto"
          :loading="loading"
          show-loading-text
          :label="$t('actions.show_more_tutors')"
          @click="showMore"
        />
      </div>

      <noscript v-if="$isServer">
        <TeacherListPaginationDisableJS class="mt-8" @pageChanged="pageChanged" />
      </noscript>
    </div>
    <TeacherListPlaceholder v-else />
    <TeacherListReview :name="allDialogs.TUTOR_LIST_REVIEW" />
    <TeacherListItemSelectTutorDialog
      :name="allDialogs.SELECT_TUTOR"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import TeacherListItems from '@/components/common/teacher-list-items/teacher-list-items.vue'
import TeacherListPaginationDisableJS
from '@/components/pages/tutor-list/teacher-list/teacher-list-pagination-disable-js.vue'
import TutorListHeader from '@/components/pages/tutor-list/teacher-list/teacher-list-header.vue'
import TeacherListPlaceholder from '@/components/pages/tutor-list/teacher-list/teacher-list-placeholder.vue'
import TeacherListReview
from '@/components/pages/tutor-list/teacher-list/teacher-list-review/teacher-list-review.vue'
import TeacherListItemSelectTutorDialog
from '@/components/common/teacher-list-items/teacher-list-items-select-tutor-dialog.vue'

export default {
  name: 'TutorListTeacherList',
  components: {
    TeacherListItemSelectTutorDialog,
    TeacherListReview,
    TeacherListPlaceholder,
    TutorListHeader,
    TeacherListPaginationDisableJS,
    TeacherListItems
  },
  data () {
    return {
      isMounted: false,
      isLoaded: false,
      page: this.$route.query.page_number ? parseInt(this.$route.query.page_number) : 1,
      loading: false,
      listFetchedAuto: false
    }
  },
  computed: {
    ...mapGetters('dialog', ['allDialogs']),
    ...mapGetters('local', ['getListParams', 'getListQueries']),
    ...mapGetters('global', ['getPagination']),
    ...mapGetters('teacher', ['getTeacherList']),
    ...mapGetters('course', ['getCourseId', 'getTypeSelected']),
    teacherList () {
      return this.getTeacherList
    },
    showMoreStatus () {
      return this.teacherList.length < this.getPagination?.total
    }
  },
  beforeDestroy () {
    window.addEventListener('scroll', this.removeScroll)
  },
  mounted () {
    this.isMounted = true
    window.addEventListener('scroll', this.handleScroll)
    setTimeout(() => {
      this.isLoaded = true
    }, 2000)
  },
  methods: {
    ...mapActions('dialog', ['showDialog']),
    ...mapActions('teacher', ['updateSelectedTeacher']),
    ...mapActions('local', ['updateListQueries', 'fetchTutorList']),
    reviewClicked (teacher) {
      this.updateSelectedTeacher(teacher)
      this.$nextTick(() => {
        this.showDialog(this.allDialogs.TUTOR_LIST_REVIEW)
      })
    },
    async pageChanged (page) {
      if (Number(this.$route?.query?.page_number) !== page) {
        await this.updateListQueries({ page_number: page })
        this.$emit('updatedData')
      }
    },
    async showMore () {
      try {
        this.loading = true
        let page = this.getListQueries?.page_number ? parseInt(this.getListQueries.page_number) : 1
        page++
        const query = { page_number: page, ignore_skip: false }
        if (this.$route.query.teacher_gender) {
          query.teacher_gender = this.$route.query.teacher_gender
        }
        await this.updateListQueries(query)
        const resp = await this.fetchTutorList()
        if (resp.status === 'ERROR') {
          console.log('ERROR')
        } else {
          const queryStr = this.$route.query.teacher_gender ? '?page_number=' + page + ',teacher_gender=' + this.$route.query.teacher_gender : '?page_number=' + page
          window.history.pushState(null, null, queryStr)
        }
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    sortClicked () {
      this.showDialog(this.allDialogs.TUTOR_LIST_SORT)
    },
    filterClicked () {
      this.showDialog(this.allDialogs.MOBILE_FILTER)
    },
    bookingClicked (id) {
      // this.showDialog(this.allDialogs.SELECT_TUTOR)
      const route = this.localePath({
        name: this.$routes.tutor_request_form.name,
        query: {
          teacher_id: id,
          course_id: this.getTypeSelected === 'SIBLINGS' ? this.getCourseId : null
        }
      })
      this.$router.push(route)
    },
    handleScroll () {
      if (this.$refs.showMoreBtn) {
        const r = this.$refs.showMoreBtn.getBoundingClientRect()
        if (this.isLoaded && r.top < 1000 && r.top > 900 && !this.listFetchedAuto && this.showMoreStatus && this.page === 1) {
          this.showMore()
          this.listFetchedAuto = true
        }
      }
    },
    removeScroll () {
      this.listFetchedAuto = false
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-list {
  @apply mt-4 lg:mt-6;
}
</style>
